import React from "react";
import { getData } from "../utils";

class CalendarSummary extends React.Component {
  state = {
    upcoming_events: [],
    lastDate: "",
    upcoming_event_html: "",
    dateLine: "",
    currentItems: "",
  };

  async loadCalendarData() {
    const data = (
      await getData(
        [],
        {},
        {
          showDeleted: false,
          timeMin: this.props.startDate,
          ...(this.props.endDate && {
            timeMax: this.props.endDate,
          }),
        }
      )
    ).data;
    this.setState({
      upcoming_events: data,
    });
  }

  async componentDidMount() {
    await this.loadCalendarData();
    await this.getUpcomingEventHtml();
  }

  async getUpcomingEventHtml() {
    let newListItems = "";

    this.state.upcoming_events.forEach((eventValue) => {
      let date = new Date(eventValue.start.dateTime);

      let content = "";

      if (eventValue.start.dateTime === this.state.lastDate) {
        this.setState({
          currentItems:
            this.state.currentItems +
            '<span class="dayEventValue">' +
            eventValue.summary +
            "</span>",
        });
      } else {
        if (this.state.lastDate !== "") {
          content =
            "<tr><td>" +
            this.state.dateLine +
            "</td><td>" +
            this.state.currentItems +
            "</td></tr>";
        }

        this.setState({
          dateLine:
            '<span class="eventsDay">' +
            date.toLocaleDateString(undefined, { weekday: "long" }) +
            "</span> " +
            date.toLocaleDateString(undefined, { month: "long" }) +
            " " +
            date.getDate(),
          currentItems:
            '<span class="dayEventValue">' + eventValue.summary + "</span>",
        });
      }

      this.setState({
        lastDate: eventValue.start.dateTime,
      });

      newListItems += content;
    });

    this.setState({
      upcoming_event_html: this.state.upcoming_events
        ? this.state.upcoming_event_html + newListItems
        : "<tr><td col=2 class='noEvents'>No upcoming events</td></tr>",
      lastDate: "",
    });
  }

  render() {
    return (
      <div className="fortnightEvents">
        <table>
          <tbody
            dangerouslySetInnerHTML={{ __html: this.state.upcoming_event_html }}
          ></tbody>
        </table>
      </div>
    );
  }
}

export default CalendarSummary;
